"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
import { FaCheck } from "react-icons/fa";
import { crmPanels } from "./crm.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function CrmPanels() {
  const $ = _c(21);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true,
      amount: 0.3
    };
    t4 = {
      duration: 0.7,
      ease
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="font-poppins mb-4 text-[28px] font-bold leading-[1.3] text-[#0b1354] md:text-[40px] dark:text-white">Essential Features for Every Panel</h2>;
    t6 = <p className="mx-auto mb-0 max-w-[840px] font-sans text-[16px] font-normal leading-[31px] text-[#6b7280] md:text-[17px] dark:text-gray-400">Our on-demand home service app includes dedicated admin, service provider, and user panels for a seamless experience.</p>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t7 = <motion.div initial={t0} whileInView={t1} animate={t2} viewport={t3} transition={t4} className="mx-auto mb-12 max-w-[880px] text-center md:mb-16">{t5}{t6}</motion.div>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== desktopAnimations) {
    t8 = crmPanels.map(panel => {
      const checkBg = panel.check === "green" ? "bg-[#22c55e]" : "bg-[#3b82f6]";
      const imageFirst = panel.imageSide === "left";
      return <motion.div key={panel.title} initial={desktopAnimations ? {
        opacity: 0,
        y: 40
      } : false} whileInView={desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined} animate={desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.75,
        delay: 0.05,
        ease
      }} className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-12"><div className={`relative mx-auto flex w-full max-w-[580px] items-center justify-center ${imageFirst ? "lg:order-1" : "lg:order-2"}`}><Image src={panel.image} alt={panel.imageAlt} width={1200} height={1000} className="relative z-10 h-auto w-full object-contain" /></div><div className={`text-center lg:text-left ${imageFirst ? "lg:order-2" : "lg:order-1"}`}><h3 className="font-poppins mb-4 text-[28px] font-bold leading-[1.3] text-[#0b1354] md:text-[36px] dark:text-white">{panel.title}</h3><p className="mb-8 font-sans text-[16px] font-normal leading-[30px] text-[#6b7280] md:text-[17px] dark:text-gray-400">{panel.description}</p><ul className="m-0 grid list-none grid-cols-1 gap-x-10 gap-y-[30px] p-0 sm:grid-cols-2">{panel.features.map(feature => <li key={feature} className="flex items-center gap-[18px] text-left"><span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[14px] text-white ${checkBg}`}><FaCheck /></span><span className="font-poppins text-[16px] font-bold leading-[24px] text-[#0b1354] md:text-[17px] dark:text-white">{feature}</span></li>)}</ul></div></motion.div>;
    });
    $[14] = desktopAnimations;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <div className="flex flex-col gap-16 md:gap-24">{t8}</div>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <section className="bg-white py-[70px] transition-colors duration-300 md:py-[100px] dark:bg-gray-950"><div className="mx-auto w-full max-w-[1290px] px-[15px]">{t7}{t9}</div></section>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}